import { gql } from '@apollo/client'

const listCustomers = gql(`
  query listCustomers($offset: Int, $limit: Int, $searchTerm: String $project: String $userGroup: String) {
      listCustomers(
        limit: $limit,
        offset: $offset,
        searchTerm: $searchTerm
        project: $project
        userGroup : $userGroup
      ) {
        users {
          id
          firstName
          lastName
          email
          mobile
          externalId
          cognitoUserId
          eligibleForHyperion
          activeSubscriptions {
            id
          },
          
        }
        numberOfHits
      }
  }`)

export default listCustomers
